module.exports = __webpack_public_path__ + "static/media/workplace-640.ad8aed08.jpg";